<template>
  <div :class="`${rowClass} h-100 text-block`">
      <div :class="`${colClass} h-100`">
      <div v-if="!!html" v-html="html"></div>
      <p v-if="!html" class="text-muted">
        {{ trans('text') }}...
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    computed: {
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        if (this.block.span_row == null && this.block.image_percent == 0.3333) {
          this.block.image_percent = 1.0
        }
        return this.block.span_row ? _.getColClass(this.block) : null
      },
      html() {
        if (!this.block.with_heading_anchor_tag) return this.block.text
        return _.getHtmlWithAnchor(this.block.text)
      },
    },
    data() {
      return {
        trans: trans,
      }
    },
  }
</script>